import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';

export interface AuthGuardSettings {
  userLocalStorageKey: string;
  allowedRoles: string[];
  signinRoute: string;
  excludedRoutes: string[];
}

function safeParse(value: string): { role: unknown } | null {
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
}

export function getAuthGuard(settings: AuthGuardSettings) {
  const authGuard: CanActivateFn = () => {
    const router = inject(Router);

    const currentUserString = localStorage.getItem(
      settings.userLocalStorageKey
    );
    const currentUser =
      currentUserString && currentUserString !== 'undefined'
        ? safeParse(currentUserString)
        : null;

    if (currentUser) {
      if (
        typeof currentUser.role === 'string' &&
        settings.allowedRoles.includes(currentUser.role)
      ) {
        return true;
      } else if (Array.isArray(currentUser.role)) {
        let matchedRole = 0;
        currentUser.role.forEach((role: string) => {
          if (settings.allowedRoles.includes(role)) {
            matchedRole += 1;
          }
        });
        if (matchedRole > 0) {
          return true;
        }
      }
    } else {
      let matchedRoute = 0;
      settings.excludedRoutes.forEach((route: string) => {
        if (window.location.href.includes(route)) {
          matchedRoute += 1;
        }
      });
      if (matchedRoute > 0) {
        return true;
      }
    }

    router.navigate([settings.signinRoute]).catch(() => false);
    return false;
  };

  return authGuard;
}
